import { formatCustomDate } from "helpers/dateTools"

export const initialValues = {
  "startDate": formatCustomDate(new Date(), '-'),
  "endDate": formatCustomDate(new Date(), '-'),
  "station": "",
  "stations": "",
  "agents": []
}
  
export const fieldValidations = {
  "startDate": {
    "required": true
  },
  "endDate": {
    "required": true
  },
  "stations": {
    "required": true
  }
}
  
export const orderDetailsInitialInputs = {
  "date": "",
  "schedule": "",
  "unit": "",
  "status": "",
  "cause": "",
  "_coupon": "",
  "couponDesc": "",
  "coupon": "",
  "discount": 0,
  "paymentType": "",
  "origin": "OTHER",
  "isAsap": false,
}

export const orderDetailsFieldValidations = {
  "date": { required: true },
  "schedule": { required: true },
  "unit": { required: true },
  "status": { required: true },
  "cause": { required: true }
}